/*===========================================
set
true or false
=========================================== */
//pegetop���帥�渇��筝㏍�ф②����
//var pagetopStop = true;
//PC SP �糸������挘��
var imageSwitch = true;

var breakWidth = 768;

//header�阪�
$(function () {
  var $win = $(window),
    $main = $('main'),
    $header = $('header'),
    $nav = $('nav'),
    headerHeight = $header.outerHeight(),
    footerHeight = $('footer').outerHeight(),
    docmentHeight = $(document).height(),
    headerPos = $header.offset().top,
    fixedClass = 'is-fixed',
    hideClass = 'is-hide';

  $win.on('load scroll', function () {
    var value = $(this).scrollTop(),
      scrollPos = $win.height() + value;

    if (value > headerPos) {
      if (docmentHeight - scrollPos <= footerHeight) {
        $header.addClass(hideClass);
      } else {
        $header.removeClass(hideClass);
      }
      $header.addClass(fixedClass);
      $main.css('margin-top', headerHeight);
    } else {
      $header.removeClass(fixedClass);
      $main.css('margin-top', '0');
    }
  });
});

/*===========================================
function
=========================================== */

(function ($) {
  // �鴻�������帥����������viewport�����帥��
  /*$(function(){
    var ua = navigator.userAgent;
    if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
        $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
    } else {
        $('head').prepend('<meta name="viewport" content="width=1000">');
    } 
});
*/
  //scroll
  $(function () {
    var topBtn = $('.to-top');
    //���帥�潟����茵�ず������
    topBtn.hide();
    //�鴻���㏍�若���������若�吾����������100�������������帥�潟��茵�ず
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        topBtn.fadeIn();
      } else {
        // ��������������//���с�若���≪�����ч��茵�ず
        topBtn.fadeOut();
      }
    });
    //�鴻���㏍�若�������������御�祉��
    topBtn.click(function () {
      $('body,html').animate(
        {
          scrollTop: 0,
        },
        500
      );
      return false;
    });
  });

  /*$(function() {
var pagetop = $('.pagetop');
pagetop.css({'display': 'none'});
$(window).scroll(function () {
if ($(this).scrollTop() > 100) {
pagetop.fadeIn();
} else {
pagetop.fadeOut();
}
});
});

$(function() {
$('a[href^=#]' + 'a:not(.non-scroll)').click(function ()  {
var href= $(this).attr('href');
var target = $(href == '#' || href == '' ? 'html' : href);
var position = target.offset().top;
$('html,body').animate({scrollTop: position}, 500, 'swing');
return false;
});
});
*/
  //tellink
  $(function () {
    var ua = navigator.userAgent;
    if (
      (ua.indexOf('iPhone') > 0 && ua.indexOf('iPod') == -1) ||
      (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0 && ua.indexOf('SC-01C') == -1 && ua.indexOf('A1_07') == -1)
    ) {
      $('.tel-link img').each(function () {
        var alt = $(this).attr('alt');
        $(this).wrap($('<a>').attr('href', 'tel:' + alt.replace(/-/g, '')));
      });
    }
  });
  //txt tellink
  $(function () {
    var ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) {
      $('.tel-call').each(function () {
        var str = $(this).text();
        $(this).html(
          $('<a>')
            .attr('href', 'tel:' + str.replace(/-/g, ''))
            .append(str + '</a>')
        );
      });
    }
  });

  //header�阪�
  /*$(function() {
  var $win = $(window),
      $main = $('main'),
      $header = $('header'),
			$nav = $('nav'),
      headerHeight = $header.outerHeight(),
      footerHeight = $('footer').outerHeight(),
      docmentHeight = $(document).height(),
      headerPos = $header.offset().top,
      fixedClass = 'is-fixed',
      hideClass = 'is-hide';

  $win.on('load scroll', function() {
    var value = $(this).scrollTop(),
        scrollPos = $win.height() + value;

    if ( value > headerPos ) {
      if ( docmentHeight - scrollPos <= footerHeight ) {
        $header.addClass(hideClass);
      } else {
        $header.removeClass(hideClass);
      }
      $header.addClass(fixedClass);
      $main.css('margin-top', headerHeight);
    } else {
      $header.removeClass(fixedClass);
      $main.css('margin-top', '0');
    }
  });
});*/

  //
  //�������若������������潟�潟���潟����筝�����
  /*$(function() {
	var height=$("#header").height();
	$("body").css("margin-top", height);
});
*/
  /* header animation for SP only
------------------------------------- */
  /*	if(breakWidth >= $(window).width()){
		$(function() {
			var $win = $(window),
					$header = $('#gHeader'),
					animationClass = 'is_animation';

			$win.on('load scroll', function() {
				var value = $(this).scrollTop();
				if ( value > 100 ) {
					$header.addClass(animationClass);
				} else {
					$header.removeClass(animationClass);
				}
			});
		});
	}
*/
  /* drawer menu for sp only
------------------------------------- */
  $(function () {
    var $nav = $('.js-drawr-menu');
    var $navBtn = $('#js-btn');
    var $speed = 300;
    var $navW = 293;
    $('body').on('touchend', '#js-btn', function () {
      drawerFunc();
    });
    $('body').on('touchend', '.overlay', function () {
      drawerFunc();
    });
    function drawerFunc() {
      if ($('body').hasClass('is_open')) {
        $('body').removeClass('is_open');
        $nav.animate({ right: -1 * $navW }, $speed, 'swing');
        $('.overlay').fadeOut($speed);
      } else {
        $('body').addClass('is_open');
        if (!$('.overlay').length) {
          $('#wrapper').prepend('<div class="overlay"></div>');
        }
        $nav.animate({ right: 0 }, $speed, 'swing');
        $('.overlay').fadeIn($speed);
      }
    }
  });

  /* accordion menu for sp only
------------------------------------- */
  /*if(breakWidth >= $(window).width()){
		if($('ul.children').length){
			$('ul.children').after('<span class="accordionBtn"><span class="line"></span><span class="line"></span></span>');
			$('ul.children').hide();
			$('ul .accordionBtn').on('click', function(){
				$(this).prev('ul.children').slideToggle();
				$(this).toggleClass('active');
			});
		}
	}*/

  /* switch-img
------------------------------------- */
  if (imageSwitch) {
    $(function () {
      var replaceWidth = 768;
      function imageSwitch() {
        var windowWidth = parseInt($(window).width());
        $('img[src*="_sp."],img[src*="_pc."]').each(function () {
          if (windowWidth >= replaceWidth) {
            $(this).attr('src', $(this).attr('src').replace('_sp.', '_pc.'));
          } else {
            $(this).attr('src', $(this).attr('src').replace('_pc.', '_sp.'));
          }
        });
      }
      imageSwitch();
      var resizeTimer;
      $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          imageSwitch();
        }, 200);
      });
    });
  }

  //�≪�潟�若���ｃ����
  $(document).ready(function () {
    //acordion_tree��筝�����茵�ず��
    $('.acordion_tree:not(:first)').css('display', 'none');
    //trigger����������������札筝���絎�茵�
    $('.trigger').click(function () {
      //������������������trigger���翫���.acordion_tree����茵�ず����
      if ($('+.acordion_tree', this).css('display') == 'none') {
        //class��active��菴遵��
        $(this).addClass('active');
        //�翫���acordion_tree���鴻���ゃ��������
        $('+.acordion_tree', this).slideDown('normal');
      } else {
        //class����active������
        $(this).removeClass('active');
        //������������trigger���翫���.acordion_tree��茵�ず�����������違�鴻���ゃ���≪����
        $('+.acordion_tree', this).slideUp('normal');
      }
    });
  });
})(jQuery);
